module.exports = __webpack_public_path__ + "img/emailLogoDetailCampus.66fe9f8.png";